<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-flex xs12>
          <v-flex xs12 class="mt-1">
            <message :messages="messages"></message>
          </v-flex>
          <v-card>
            <v-flex xs12>
              <form data-vv-scope="filters">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-container fluid grid-list-lg>
                            <v-layout row wrap>
                              <v-flex md6 xs12>
                                <v-text-field
                                  v-model="filters.id"
                                  :label="labels.id"
                                  :error-messages="errors.collect('filters.id')"
                                  data-vv-name="filters.id"
                                  :data-vv-as="labels.id"
                                ></v-text-field>
                              </v-flex>
                              <v-flex md6 xs12>
                                <v-text-field
                                  v-model="filters.batchName"
                                  :label="labels.batchName"
                                  :error-messages="errors.collect('filters.batchName')"
                                  data-vv-name="filters.batchName"
                                  :data-vv-as="labels.batchName"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                          <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </form>
            </v-flex>
            <v-spacer class="mt-2"></v-spacer>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="items"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                :loading="loading"
                :server-items-length="totalItems"
                :no-data-text="noDataText"
                v-bind:options.sync="pagination"
              >
                <template v-slot:item="row">
                  <tr>
                    <td class="text-xs-left">{{ row.item.id }}</td>
                    <td class="text-xs-left">{{ row.item.batchName }}</td>
                    <td class="text-xs-left">
                      <v-layout row wrap align-center>
                        <v-flex xs2 v-if="itemId === row.item.id && enableHeapSizeUpdate === true">
                          <v-autocomplete
                            :items="heapSizes"
                            v-model="row.item.heapSize"
                            item-text="label"
                            item-value="value"
                            data-vv-name="labels.heapSize"
                            :data-vv-as="row.item.heapSize"
                          ></v-autocomplete>
                        </v-flex>
                        <div v-else>{{ row.item.heapSize + 'GB' }}</div>
                        <v-btn text icon :color="itemId === row.item.id && enableHeapSizeUpdate === true ? 'red' : 'green'">
                          <v-icon @click="doEnableUpdate('heapSize', row.item)">{{
                            itemId === row.item.id && enableHeapSizeUpdate === true ? 'mdi-close-circle' : 'mdi-pencil'
                          }}</v-icon>
                        </v-btn>
                        <v-btn text icon color="green" v-if="itemId === row.item.id && enableHeapSizeUpdate === true">
                          <v-icon @click="doUpdate('heapSize', row.item)">mdi-check-circle</v-icon>
                        </v-btn>
                      </v-layout>
                    </td>
                    <td class="text-xs-left">
                      <v-switch v-model="row.item.enabled" :false-value="false" :true-value="true" hide-details @change="doUpdate('', row.item)">
                      </v-switch>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { formatDisplayDate, formatDisplayDateTime } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  data() {
    return {
      selectedJob: undefined,
      totalItems: 0,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Batch Name', value: 'batchName' },
        { text: 'Heap Size (GB)' },
        // { text: 'Arguments', value: 'arguments' },
        // { text: 'Path/Location', value: 'path' },
        { text: 'Batch Enabled', value: 'enabled' }
      ],
      labels: {
        id: 'Id',
        batchName: 'Batch Name',
        instantTerminate: 'Instant Terminate',
        enabled: 'Batch Enabled',
        heapSize: 'Heap Size',
        arguments: 'Arguments',
        path: 'File Path / Location'
      },
      filters: {
        id: null,
        batchName: null
      },
      forms: {
        enabled: false,
        instantTerminate: false
      },
      pagination: {
        sortDesc: [false],
        page: 1
      },
      loading: false,
      enablePathUpdate: false,
      enableArgumentsUpdate: false,
      enableHeapSizeUpdate: false,
      itemId: null
    }
  },
  methods: {
    async fetchBatchJobs(options) {
      const apiURI = this.batchmenu.bchMngJobSettings
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            const { data } = result
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              this.$set(this, 'items', data.data)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filters').then(result => {
        if (result) {
          this.fetchBatchJobs(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDisplayDate(myDate) {
      return formatDisplayDate(myDate)
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime(myDate)
    },
    doClearFilters() {
      this.filters.id = null
      this.filters.instantTerminate = null
      this.filters.batchName = null
      this.filters.enabled = null
      this.filters.jobEnd = null
      this.filters.createdBy = null
      this.fetchBatchJobs(false)
    },
    async doUpdate(type, item) {
      const apiURI = this.batchmenu.bchMngJobUpdate
      if (apiURI) {
        this.loading = true
        const expand = {
          id: item.id,
          batchName: item.batchName,
          artifactName: item.artifactName,
          arguments: item.arguments,
          path: item.path,
          instantTerminate: item.instantTerminate,
          enabled: item.enabled,
          heapSize: item.heapSize
        }
        try {
          const result = this.$http.put(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
            this.fetchBatchJobs(false)
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
        this.doSetUpdateSwith(type)
      }
    },
    doEnableUpdate(type, item) {
      this.itemId = item.id
      this.doSetUpdateSwith(type)
    },
    doSetUpdateSwith(type) {
      switch (type) {
        case 'arguments':
          this.enableArgumentsUpdate = !this.enableArgumentsUpdate
          break
        case 'path':
          this.enablePathUpdate = !this.enablePathUpdate
          break
        case 'heapSize':
          this.enableHeapSizeUpdate = !this.enableHeapSizeUpdate
          break
        default:
          this.enableArgumentsUpdate = false
          this.enablePathUpdate = false
          this.enableHeapSizeUpdate = false
          break
      }
    }
  },
  watch: {
    pagination: function(value) {
      this.fetchBatchJobs(false)
    },
    '$store.state.user.notification.batchJobStatus': function(value) {
      if (value) {
        this.fetchBatchJobs(false)
      }
    }
  },
  mounted() {
    this.fetchBatchJobs(false)
  },
  computed: {
  },
  mixins: [TableConst.default, MessageMixin, batchManagerMixin]
}
</script>
